import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'
import Dialog from '@material-ui/core/Dialog'

import { Colors } from '../../../styles'

export const TooltipsWrapper = styled.div`
  z-index: 1000;
  transform: rotate(${(props) => props.deg}deg);
`

export const Box = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
`

export const Tooltips = styled(ReactTooltip)`
  min-width: 175px;
`

export const TittleTooltips = styled.span`
  color: ${Colors.grey};
`

export const ContentTooltips = styled.div`
  padding-left: 10px;
  color: ${Colors.black};
`

export const Jetty = styled.div`
  position: absolute;
  width: 22%;
  height: 15%;
  top: ${(props) => props.top}; // e.g. '22%'
  left: ${(props) => props.left}; // e.g. '64%'
  display: flex;
  align-items: flex-end;
  justify-content: center;
  transform: rotate(${(props) => props.rotate || '0deg'});
  z-index: 2;

  &:hover {
    z-index: 3;
  }
`

export const Vessel = styled.img`
  width: ${(props) => props.width || 'auto'};
  height: ${(props) => props.height || '100%'}; // e.g. '100%', '80%', '60%'
  transform: rotate(${(props) => props.rotate || '0deg'});
  transform-origin: bottom center;
`
export const TOJContainer = styled.div`
  position: absolute;
  display: flex;
  gap: 8px;
  align-items: center;
  flex-direction: column-reverse;
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  z-index: 1000;
  transform: ${({ isDolphin }) =>
    `translateX(-50%) rotate(${isDolphin ? '0deg' : '-90deg'}) scale(1)`};
`

export const TOJItem = styled.div`
  width: 100%;
  height: 3.75rem;
  display: flex;
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 999px;
  align-items: center;
  justify-content: start;
  border: 1px solid ${Colors.white};
  background-color: ${Colors.white};
  transform: scale(1) !important;
`
export const TOJInfoWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 3.65rem;
  display: flex;
  align-items: center;
`
export const TOJItemFilled = styled.div`
  top: 0;
  left: 0;
  bottom: 0;
  cursor: pointer;
  position: absolute;
  border-radius: inherit;
  transition: width 0.3s ease;
  background-color: ${Colors.topaz};
  width: ${(props) => props.percentage || 0}%;
`
export const TOJCircleWrapper = styled.div`
  border-top-left-radius: 999px;
  border-bottom-left-radius: 999px;
  background-color: ${(props) =>
    props.percentage ? Colors.topaz : Colors.white};
`

export const TOJItemFillWrapper = styled.div`
  position: absolute;
  inset: 0px 0px 0px 0px;
  width: 100%;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
`
export const TOJCirclePercentage = styled.div`
  width: 3.65rem;
  height: 3.65rem;
  display: flex;
  font-size: 1rem; /* Ukuran font tetap */
  cursor: inherit;
  font-weight: 800;
  border-radius: 100%;
  align-items: center;
  justify-content: center;
  border: 1px solid ${Colors.white};
  background-color: ${Colors.najavoWhite};
`
export const TOJDescription = styled.div`
  z-index: 1;
  display: flex;
  cursor: inherit;
  padding: 0px 2px 0px 2px;
  flex-direction: column;
  justify-content: start;
`

export const TOJValueWrapper = styled.div`
  display: flex;
  cursor: inherit;
  align-items: center;
  justify-content: start;
`

export const TOJName = styled.label`
  font-size: 0.8rem;
  cursor: inherit;
  max-width: 5rem;
  font-weight: 700;
  color: ${Colors.black};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`
export const TOJMaxValue = styled.label`
  font-size: 0.8rem;
  cursor: inherit;
  font-weight: 700;
  color: ${Colors.black};
`
export const TOJValue = styled.label`
  font-size: 0.8rem;
  cursor: inherit;
  font-weight: 600;
  color: ${Colors.black};
`

export const Modal = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 8px;
    max-width: 580px;
    border: 1px solid ${Colors.white};
  }
`

export const ModalHeader = styled.div`
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${Colors.softBlue};
`
export const ModalTitle = styled.label`
  color: ${Colors.white};
  font-weight: 700;
  font-size: 20px;
`
export const ModalTOJName = styled.div`
  font-weight: 700;
  font-size: 16px;
  padding: 8px 24px;
  color: ${Colors.softBlue};
  background-color: #f5f5f5;
`

export const ModalContent = styled.div`
  gap: 8px;
  display: flex;
  overflow-y: auto;
  max-height: 40rem;
  padding: 16px 24px;
  flex-direction: column;
  background-color: ${Colors.white};
`
export const FormContainer = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
`
export const FormWrapper = styled.div`
  flex: 1;
`
export const ItemWrapper = styled.div`
  gap: 8px;
  width: 100%;
  display: flex;
  flex-direction: column;
`
export const ProgressItem = styled.div`
  width: 100%;
  display: flex;
  padding: 6px 24px;
  border-radius: 8px;
  background-color: #e8e8e8;
  justify-content: space-between;
`
export const Label = styled.label`
  font-weight: 600;
  font-size: 14px;
  color: ${Colors.cancelTextColor};
`
export const Percentage = styled.label`
  font-weight: 700;
  font-size: 14px;
  color: ${Colors.softBlue};
`
export const CloseButton = styled.button`
  cursor: pointer;
  background: none;
  border: none;
  padding: 0;
  outline: none;
`
